/* !
 * jQuery prodDetail v1.0.0
 * Copyright 2021, Connecty Inc.
 */
(function ($, SANGETSU, cssua) {
	const a = 'is-active';
	const v = 'is-visible';
	const slideSpeed = 'fast';
	const thisPn = SANGETSU.va.pathname.split('/')[3];

	// メイン商品画像処理
	const mainImg = () => {
		let currentImg, currentImgIdx;

		// ホバー（モバイルはクリック）でメイン画像切り替え
		const changeImg = (_thisImg) => {
			if (!$(_thisImg).hasClass(a)) {
				// カレント変更（モーダル表示用）
				currentImg = _thisImg;
				if (!$(currentImg).hasClass('vp_tile_single_pict_list')) {
					currentImgIdx = $('.prodDetail-prodImg-list .__listImg').index($(_thisImg));
				} else {
					currentImgIdx = $('.prodDetail-prodImg-list._tile .__listImg').index($(_thisImg));
				}

				$('.__listImg').each((idx, ele) => { $(ele).removeClass(a) });
				$(_thisImg).addClass(a);

				$('.js-prodImg-mainImg').find('.__mainImg.is-visible').removeClass(v);
				$('.js-prodImg-mainImg').find('.__mainImg').eq($('.__listImg').index($(_thisImg))).addClass(v);

				$('.js-prodImg-caption').text($(_thisImg).attr('data-caption'));
			}
		};
		if (cssua.ua.desktop) {
			$('.__listImg').mouseenter((e) => { changeImg(e.currentTarget); });
		} else {
			$('.__listImg').on('click', (e) => { changeImg(e.currentTarget); });
		}

		// リスト部分カルーセル
		const mainImgListCarousel = () => {
			$('.js-prodImg-carousel').each((idx, ele) => {
				$(ele).owlCarousel({
					items: 5,
					slideSpeed: 300,
					paginationSpeed: 400,
					pager: false,
					pagination: false,
					margin: 10,
					nav: true,
					navText: ['', '']
				});
			});
		};
		if (cssua.ua.desktop) {
			mainImgListCarousel();
		}

		// モーダル作成
		const setMainImgModal = () => {
			$('.__mainImg').on('click', () => {
				$('.prodDetail-prodImg-modal-list').each((idx, ele) => { $(ele).removeClass(a); })

				let $carousel;
				if (!$(currentImg).hasClass('vp_tile_single_pict_list')) {
					$('.prodDetail-prodImg-modal-list._default').addClass(a);
					$carousel = $('.prodDetail-prodImg-modal-list._default .js-prodImg-modal-carousel');
				} else { // タイル一枚画像は別カルーセル
					$('.prodDetail-prodImg-modal-list._tile').addClass(a);
					$carousel = $('.prodDetail-prodImg-modal-list._tile .js-prodImg-modal-carousel');
				}
				$carousel.owlCarousel({
					items: 1,
					slideSpeed: 300,
					paginationSpeed: 400,
					pager: false,
					pagination: false,
					nav: true,
					navText: ['', '']
				});
				$carousel.trigger('to.owl.carousel', [currentImgIdx, slideSpeed]);

				$('.mod-modal-overlay').addClass(v).fadeIn(slideSpeed);
				$('.mod-modal').fadeIn(slideSpeed);
			});
		};
		setMainImgModal();


		///////////////////////////////////////// test /////////////////////////////////////////
		// $('.mod-loader').remove();
		// $('.prodDetail-wrap').addClass(v);
		///////////////////////////////////////// test /////////////////////////////////////////


		// メイン画像群の読み込み完了後に各処理実行
		let promiseImgLoad = new Promise((resolve) => {
			let count = 0;

			$('.__listImg').each((idx, ele) => {
				let prodImg = new Image();
				let caption = '';
				prodImg.onload = () => {
					// 各画像のキャプション作成
					if ($(ele).find('img').hasClass('vp_chip_pict')) { caption = `チップ画像`; }
					else if ($(ele).find('img').hasClass('vp_repeat_pict')) { caption = `画像サイズ(実寸換算) タテ${prodImg.naturalHeight}mm／ヨコ${prodImg.naturalWidth}mm`; }
					else if ($(ele).find('img').hasClass('vp_tile_combine_pict')) { caption = `タイル組合せ画像(実寸サイズ タテ${prodImg.naturalHeight}mm／ヨコ${prodImg.naturalWidth}mm)`; }
					else if ($(ele).find('img').hasClass('vp_tile_single_pict')) { caption = `タイル一枚画像(実寸サイズ タテ${prodImg.naturalHeight}mm／ヨコ${prodImg.naturalWidth}mm)`; }
					else { caption = '　'; }
					$(ele).attr('data-caption', caption);

					count++;
					if (count === $('.__listImg').length) {
						return resolve('Success');
					}
				};
				prodImg.onerror = () => {
					count++;
					if (count === $('.__listImg').length) {
						return resolve('Success');
					}
				}
				prodImg.src = $(ele).find('img').attr('src');

			});
		});
		Promise.all([promiseImgLoad]).then(() => {
			// 初期表示
			changeImg($('.__listImg')[0]);
			// ロードを外す
			$('.mod-loader').remove();
			$('.prodDetail-wrap').addClass(v);
		});

	};

	// Youtube動画リスト
	const setYoutube = () => {
		let tag = document.createElement('script');
		tag.src = '//www.youtube.com/iframe_api';
		let firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		let player;

		const setPlayer = (_videoID) => {
			player = new window.YT.Player('videoPlayer', {
				height: 360,
				width: 640,
				videoId: _videoID,
				playerVars: {
					'showinfo': 0,
					'rel': 0
				}
			});
		};
		window.onload = () => {
			// 初期表示
			setPlayer($('.__video').eq(0).find('.vp_movie_code').attr('data-id'));
			$('.__video').eq(0).addClass(a);

			if ($('.__video').length === 1) {
				// 動画が一つだけならサムネリスト削除
				$('.prodDetail-video-list').remove();
			} else {
				// サムネカルーセル
				$('.prodDetail-video-list').owlCarousel({
					slideSpeed: 300,
					paginationSpeed: 400,
					pager: false,
					pagination: false,
					margin: 10,
					nav: true,
					navText: ['', ''],
					responsive: {
						0: {
							items: 2
						},
						768: {
							items: 3
						}
					}
				});

				$('.__video').each((idx, ele) => {
					// サムネ画像セット
					let videoID = $(ele).find('.vp_movie_code').attr('data-id');
					$(ele).append(`<img src="https://i.ytimg.com/vi/${videoID}/default.jpg" class="width-u-100">`);

					// サムネクリックでプレーヤー切り替え
					$(ele).on('click', () => {
						$('.__video').each((idx2, ele2) => { $(ele2).removeClass(a); });
						if (player) {
							player.destroy();
						}
						setPlayer($(ele).find('.vp_movie_code').attr('data-id'));
						$(ele).addClass(a);
					});
				});
			}
		};
	};

	// チップ画像表示サイズ調整処理
	const setChipImgSize = () => {
		$('.prodDetail-chip').css('height', $('.prodDetail-contentR').width() - 30); // 正方形にする

		let chipImg = new Image();
		chipImg.onload = () => {
			if (chipImg.naturalHeight === 630) {
				$('.prodDetail-chip').find('img').addClass('width-u-100');
			} else if (chipImg.naturalHeight === 300) {
				$('.prodDetail-chip').find('img').addClass('small');
			} else {
				$('.prodDetail-chip').find('img').addClass('other');
			}
		};
		chipImg.src = $('.prodDetail-chip').find('img').attr('src');
	};

	// 価格処理
	const setPrice = () => {
		if ($('.prodDetail-price_sm').length) {
			let priceSmHTML = '，' + $('.prodDetail-price_sm').html();
			$('.prodDetail-price').append(priceSmHTML);
			$('.prodDetail-price_sm').remove();
		}
		// 価格に,を入れる
		$('.vp_sales_price').each((idx, ele) => {
			let price = $(ele).text();
			price = price.replace(/(\d)(?=(\d\d\d)+$)/g, '$1,');
			$(ele).text(price);
		});
		$('.vp_sales_price_sm').each((idx, ele) => {
			let price = $(ele).text();
			price = price.replace(/(\d)(?=(\d\d\d)+$)/g, '$1,');
			$(ele).text(price);
		});
	};

	// 仕様の値計算
	const formatSpec = () => {
		let thisProdCat = $('.js-thisProdCat').attr('data-category');

		// 仕様 - リピート :全カテゴリ
		let $rpVert = $('.vp_repeat_vert');
		let rpVert = $rpVert.text();
		if (rpVert) { Number(rpVert); }

		let $rpHori = $('.vp_repeat_hori');
		let rpHori = $rpHori.text();
		if (rpHori) { Number(rpHori); }

		let $rpbody = $('.vp_repeat').find('.__body');
		if (thisProdCat !== 'other' && !$rpbody.find('.vp_repeat_vert')) {
			$('.vp_repeat').remove();
		} else {
			let rpVertDisp = rpVert / 10;
			let rpHoriDisp = rpHori / 10;

			$rpVert.text(rpVertDisp);
			$rpHori.text(rpHoriDisp);

			let vertFlg = false,
				horiFlg = false;

			if (!rpVertDisp || rpVertDisp === '0') {
				$('.vp_repeat_vert_li').remove();
				vertFlg = true;
			}
			if (!rpHoriDisp || rpHoriDisp === '0') {
				$('.vp_repeat_hori_li').remove();
				horiFlg = true;
			}
			if (vertFlg && horiFlg) {
				$('.vp_repeat').remove();
			}
		}

		// 仕様 - 規格
		if (thisProdCat === 'wall') {
			// 規格1.規格＝規格横×規格縦
			let spec1Body = $('.vp_wall_spec1_igroup').html();
			if (spec1Body) {
				if (spec1Body.indexOf('vp_standard_hori_mm') !== -1) {
					let $spec1Hori = $('.vp_wall_spec1_igroup').find('.vp_standard_hori_mm');
					$spec1Hori.text(Number($spec1Hori.text()) / 10);
				}
				if (spec1Body.indexOf('vp_standard_vert_mm') !== -1) {
					let $spec1Vert = $('.vp_wall_spec1_igroup').find('.vp_standard_vert_mm');
					$spec1Vert.text(Number($spec1Vert.text()) / 1000);
				}
			}
			// 規格2.サイズ＝規格縦×規格横
			let spec2Body = $('.vp_wall_spec2_igroup').html();
			if (spec2Body) {
				if (spec2Body.indexOf('vp_standard_hori_mm') !== -1) {
					let $spec2Hori = $('.vp_wall_spec2_igroup').find('.vp_standard_hori_mm');
					$spec2Hori.text(Number($spec2Hori.text()) / 10);
				}
				if (spec2Body.indexOf('vp_standard_vert_mm') !== -1) {
					let $spec2Vert = $('.vp_wall_spec2_igroup').find('.vp_standard_vert_mm');
					$spec2Vert.text(Number($spec2Vert.text()) / 10);
				}
			}
		} else if (thisProdCat === 'curtain') {
			// 規格1.有効巾＝規格横×規格縦
			let _spec1Body = $('.vp_curtain_spec1_igroup').html();
			if (_spec1Body) {
				if (_spec1Body.indexOf('vp_standard_hori_mm') !== -1) {
					let _$spec1Hori = $('.vp_curtain_spec1_igroup').find('.vp_standard_hori_mm');
					_$spec1Hori.text(Number(_$spec1Hori.text()) / 10);
				}
			}
			// 規格2.サイズ＝規格横×規格縦
			let _spec2Body = $('.vp_curtain_spec2_igroup').html();
			if (_spec2Body) {
				if (_spec2Body.indexOf('vp_standard_vert_mm') !== -1) {
					let _$spec2Vert = $('.vp_curtain_spec2_igroup').find('.vp_standard_vert_mm');
					_$spec2Vert.text(Number(_$spec2Vert.text()) / 1000);
				}
			}
		} else if (thisProdCat === 'chair') {
			// 規格1.有効巾＝規格横×規格縦
			let _spec1Body2 = $('.vp_chair_spec1_igroup').html();
			if (_spec1Body2) {
				if (_spec1Body2.indexOf('vp_standard_hori_mm') !== -1) {
					let _$spec1Hori2 = $('.vp_chair_spec1_igroup').find('.vp_standard_hori_mm');
					_$spec1Hori2.text(Number(_$spec1Hori2.text()) / 10);
				}
				if (_spec1Body2.indexOf('vp_standard_vert_mm') !== -1) {
					let _$spec1Vert = $('.vp_chair_spec1_igroup').find('.vp_standard_vert_mm');
					_$spec1Vert.text(Number(_$spec1Vert.text()) / 1000);
				}
			}
			// 規格2.有効巾＝規格横×規格縦
			let _spec2Body2 = $('.vp_chair_spec2_igroup').html();
			if (_spec2Body2) {
				if (_spec2Body2.indexOf('vp_standard_vert_mm') !== -1) {
					let _$spec2Vert2 = $('.vp_chair_spec2_igroup').find('.vp_standard_vert_mm');
					_$spec2Vert2.text(Number(_$spec2Vert2.text()) / 1000);
				}
			}
			// 規格3.サイズ＝規格縦×規格横
			let spec3Body = $('.vp_wall_spec3_igroup').html();
			if (spec3Body) {
				if (spec3Body.indexOf('vp_standard_hori_mm') !== -1) {
					let $spec3Hori = $('.vp_wall_spec3_igroup').find('.vp_standard_hori_mm');
					$spec3Hori.text(Number($spec3Hori.text()) / 10);
				}
				if (spec3Body.indexOf('vp_standard_vert_mm') !== -1) {
					let $spec3Vert = $('.vp_wall_spec3_igroup').find('.vp_standard_vert_mm');
					$spec3Vert.text(Number($spec3Vert.text()) / 10);
				}
			}
		} else if (thisProdCat === 'carpet') {
			// 規格1.ロール巾＝規格横
			let _spec1Body3 = $('.vp_cpet_spec1_igroup').html();
			if (_spec1Body3) {
				let $rollWidth = $('.vp_roll_width');
				let rollWidth = $rollWidth.text();
				Number(rollWidth);
				$rollWidth.text(rollWidth * 100);
			}
			// 規格2.巾＝規格横 ※スロープ以外
			let _spec2Body3 = $('.vp_cpet_spec2_igroup').html();
			if (_spec2Body3) {
				if (_spec2Body3.indexOf('vp_standard_hori_mm') !== -1) {
					let _$spec2Hori = $('.vp_cpet_spec2_igroup').find('.vp_standard_hori_mm');
					let spec2Hori = String(_$spec2Hori.text() / 10);
					if (spec2Hori.match(/^([1-9]\d*|0)$/)) {
						_$spec2Hori.text(spec2Hori);
					} else {
						_$spec2Hori.text(Number(spec2Hori).toFixed(1));
					}
				}
			}
			// 規格3.サイズ＝規格縦×規格横
			let _spec3Body = $('.vp_cpet_spec3_igroup').html();
			if (_spec3Body) {
				if (_spec3Body.indexOf('vp_standard_hori_mm') !== -1) {
					let _$spec3Hori = $('.vp_cpet_spec3_igroup').find('.vp_standard_hori_mm');
					let spec3Hori = String(_$spec3Hori.text() / 10);
					if (spec3Hori.match(/^([1-9]\d*|0)$/)) {
						_$spec3Hori.text(spec3Hori);
					} else {
						_$spec3Hori.text(Number(spec3Hori).toFixed(1));
					}
				}
				if (_spec3Body.indexOf('vp_standard_vert_mm') !== -1) {
					let _$spec3Vert = $('.vp_cpet_spec3_igroup').find('.vp_standard_vert_mm');
					let spec3Vert = String(_$spec3Vert.text() / 10);
					if (spec3Vert.match(/^([1-9]\d*|0)$/)) {
						_$spec3Vert.text(spec3Vert);
					} else {
						_$spec3Vert.text(Number(spec3Vert).toFixed(1));
					}
				}
			}
			// 規格6.サイズ＝規格横×規格縦 (=人工芝)
			let spec6Body = $('.vp_cpet_spec6_igroup').html();
			if (spec6Body) {
				if (spec6Body.indexOf('vp_standard_hori_mm') !== -1) {
					let $spec6Hori = $('.vp_cpet_spec6_igroup').find('.vp_standard_hori_mm');
					$spec6Hori.text(Number($spec6Hori.text()) / 1000);
				}
				if (spec6Body.indexOf('vp_standard_vert_mm') !== -1) {
					let $spec6Vert = $('.vp_cpet_spec6_igroup').find('.vp_standard_vert_mm');
					$spec6Vert.text(Number($spec6Vert.text()) / 1000);
				}
			}
		} else if (thisProdCat === 'other') {
			if ($('.vp_order_unit_code') === '巻') {
				let specVert = $('.vp_standard_vert_mm').text();
				let specHori = $('.vp_standard_hori_mm').text() / 1000;
				$('.vp_spec_size').text(specVert + ' mm巾 × ' + specHori + ' m巻');
			} else {
				let _specVert = $('.vp_standard_vert_mm').text() / 10;
				let _specHori = $('.vp_standard_hori_mm').text() / 10;
				$('.vp_spec_size').text(_specHori + ' cm × ' + _specVert + ' cm');
			}
		}
	};

	// 同一商品異品番
	const diffProd = () => {
		let d = $.Deferred();
		let partNo = $('.diff_product_param .vp_part_no').text();
		let diffProdJSON = `/ajax/product/diff_product/${partNo}?item_code=${$('.diff_product_param .vp_item_code').text()}`;
		// console.log(diffProdJSON);
		$.getJSON(diffProdJSON, (data) => {
			if (data.product_list.length) {
				let prodList = data.product_list;
				let diffProdHTML = '';
				for (let i = 0; prodList.length > i; i++) {
					diffProdHTML += `<li><a href="/product/detail/${prodList[i].part_no}/">${prodList[i].part_no_disp}</a></li>`;
				}
				$('.prodDetail-diffProd-list').append(diffProdHTML);
			} else {
				$('.prodDetail-diffProd').remove();
			}
			d.resolve();
		});
		return d.promise();
	};

	// おすすめ商品（旧関連商品）
	const setRecommendList = () => {
		const recommendCarousel = () => {
			if (cssua.ua.desktop) {
				$('.prodDetail-recommend-list.__pc').owlCarousel({
					items: 5,
					slideSpeed: 300,
					paginationSpeed: 400,
					pager: false,
					pagination: false,
					margin: 10,
					nav: true,
					navText: ['', ''],
				});
			} else {
				$('.prodDetail-recommend-list.__sp').owlCarousel({
					items: 3,
					slideSpeed: 300,
					paginationSpeed: 400,
					pager: false,
					pagination: false,
					margin: 10,
					nav: true,
					navText: ['', ''],
					responsive: {
						0: {
							items: 3,
							margin: 10
						},
						768: {
							items: 5,
							margin: 20
						}
					}
				});
			}
		};
		const getRecommendList = () => {
			let d = $.Deferred();
			let list = 0;
			let partNo = encodeURIComponent($('.recommended_param .vp_part_no').text());
			let catIndex = encodeURIComponent($('.recommended_param .vp_category_index').text());
			let series = encodeURIComponent($('.recommended_param .vp_pattern_series').text())
			let recomJSON = `/ajax/product/recommended/${partNo}?catalog_code=${$('.recommended_param .vp_catalog_code').text()}` +
				`&category_index=${catIndex}&pattern_series=${series}`;

			$.getJSON(recomJSON, (data) => {
				if (data.product_list.length) {
					let prodList = data.product_list;
					let recommendHTML = '';
					for (let i = 0; prodList.length > i; i++) {
						if (prodList[i].part_no !== partNo && list < 10) {
							recommendHTML += `<div><a href="/product/detail/${prodList[i].part_no}/">` +
								`<figure><img src="//contents.sangetsu.co.jp/img/chip/${prodList[i].chip_pict[0]}">` +
								`<figcaption>${decodeURIComponent(catIndex)}<br>${prodList[i].part_no_disp}</figcaption></figure></a></div>`;
							list += 1;
							if (list === 10) {
								break;
							}
						}
					}
					if (list > 0) {
						$('.prodDetail-recommend-list').append(recommendHTML);
					} else {
						$('.prodDetail-recommend').remove();
					}
					d.resolve();
				} else {
					$('.prodDetail-recommend').remove();
				}
			});
			return d.promise();
		}

		// おすすめ商品取得
		$.when(getRecommendList()).done(() => {
			if ($('.prodDetail-recommend-list').find('img').length) {
				recommendCarousel();
			} else {
				$('.prodDetail-recommend-list').remove();
			}
		});
	};

	// 空の要素を削除、他表示調整
	const removeEmpty = () => {
		// 壁紙：防火種別にハイフンを足す
		$('.vp_fireproof_class').text($('.vp_fireproof_class').text().replace(/(\d)(?=(\d)+$)/g, '$1-'));

		// デジタルブック
		if (!$('.prodDetail-digibook').find('.rt_bn_catalog_list').length) {
			$('.prodDetail-digibook').remove();
		} else {
			// ボタン押下
			$('.prodDetail-digibook-item').each((idx, ele) => {
				if ($(ele).find('#vp_digital_book_url').attr('value')) {
					$(ele).on('click', (e) => {
						window.open($(e.currentTarget).find('#vp_digital_book_url').attr('value'));
					});
				} else {
					$(ele).find('.vp_catalog_name').addClass('_noLink');
					$(ele).find('.vp_aqua_no_manage_catalog').parent('span').addClass('_noLink');
				}
			});
		}

		// ダウンロード
		if (!$('.prodDetail-prodImg-download').find('.vp_download_pict_zip_li').length) {
			$('.prodDetail-prodImg-download').remove();
			// 画像の右クリックを禁止する
			$('.prodDetail img, .prodDetail-prodImg-modal img').on('contextmenu', () => {
				return false;
			});
			$('.prodDetail img, .prodDetail-prodImg-modal img').each((idx, ele) => {
				$(ele).attr('oncontextmenu', 'return false;');
			});
		} else {
			$('.prodDetail img, .prodDetail-prodImg-modal img').on('contextmenu', () => {
				return true;
			});
		}

		// 標準価格
		if (!$('.prodDetail-priceWrap').find('.prodDetail-price').length && !$('.prodDetail-priceWrap').find('.prodDetail-price_sm').length) {
			$('.prodDetail-priceWrap').remove();
		}

		// 洗濯アイコン毎
		$('.prodDetail-washicon .__list li').each((idx, ele) => {
			if (!$(ele).find('img').length) {
				$(ele).remove();
			}
		});
		// 洗濯表示枠
		if (!$('.prodDetail-washicon .__list').find('li').length) {
			$('.prodDetail-washicon').remove();
		}

		// ＜カーテン＞推奨スタイル
		if (!$('.prodDetail-curtainStyle .__list').find('li').length) {
			$('.prodDetail-curtainStyle').remove();
		}

		// 関連資料
		if (!$('.prodDetail-docList').find('li').length) {
			$('.prodDetail-doc').remove();
		}
		// 関連リンク
		if (!$('.prodDetail-relatedSite').find('li').length) {
			$('.prodDetail-relatedSiteWrap').remove();
		}
	};

	// 最近チェックした商品
	const setRecent = () => {
		// カルーセル
		const recentCarousel = () => {
			$('.prodDetail-recentList').owlCarousel({
				slideSpeed: 300,
				paginationSpeed: 400,
				pager: false,
				pagination: false,
				nav: true,
				navText: ['', ''],
				responsive: {
					0: {
						items: 3,
						margin: 10
					},
					768: {
						items: 5,
						margin: 20
					}
				}
			});
		};

		// 最近チェックした商品に追加
		const addRecentStorage = (_thisPn) => {
			let watchDatetime = new Date();
			watchDatetime = `${watchDatetime.getFullYear()}/${('0' + (watchDatetime.getMonth() + 1)).slice(-2)}/${(('0' + (watchDatetime.getDate())).slice(-2))} ` +
				`${('0' + (watchDatetime.getHours())).slice(-2)}:${('0' + (watchDatetime.getMinutes())).slice(-2)}:${('0' + (watchDatetime.getSeconds())).slice(-2)}`;
			localStorage.setItem('recentList-' + _thisPn, watchDatetime);
		};
		// 最近チェックした商品から削除
		const removeRecentThisItem = (_thisPn) => {
			localStorage.removeItem('recentList-' + _thisPn);
		}

		// 最近チェックした商品欄作成
		const setRecentList = (_recentStorage, _thisPn) => {
			let recentList = [];

			let p = new Promise((resolve) => {
				let count = 0;

				$.each(_recentStorage, (idx, ele) => {
					let recentProd = ele.replace(/recentList-/, '');
					let recentImg, recentCat, recentPnDisp;
					$.when($.getJSON('/ajax/product/file_url/chip_pict/' + recentProd, (data) => {
						if (data.product_list.length) {
							if (data.product_list[0].url_list.output.length) {
								recentImg = data.product_list[0].url_list.output[0].url;
							} else {
								recentImg = '/temp_noimage.jpg';
							}
						} else {
							recentImg = '/temp_noimage.jpg';
						}
					}), $.getJSON('/ajax/product/category/' + recentProd, (data) => {
						if (data.product_list.length) {
							// カテゴリ名
							let groupCode = data.product_list[0].item_group.code;
							let prodCat = data.product_list[0].product_category1.code;
							if (groupCode !== '04' && groupCode !== '06') {
								switch (groupCode) {
									case '01': recentCat = '壁紙'; break;
									case '02': recentCat = '粘着剤付化粧フィルム（リアテック）'; break;
									case '03': recentCat = 'ガラスフィルム'; break;
									case '05': recentCat = '椅子生地'; break;
									case '07': recentCat = 'カーペットタイル'; break;
									case '08': recentCat = 'フロア'; break;
									case '09': recentCat = 'フロアタイル'; break;
									case '12': recentCat = 'その他'; break;
									default: break;
								}
							} else if (groupCode === '04') {
								if (prodCat === '119') {
									recentCat = 'ロールスクリーン・ブラインド';
								} else {
									recentCat = 'カーテン';
								}
							} else if (groupCode === '06') {
								if (prodCat === '135') {
									recentCat = 'ラグ';
								} else {
									recentCat = 'カーペット';
								}
							}
							recentPnDisp = data.product_list[0].part_no_disp;
						}
					})).done(() => {
						if (recentCat) {
							recentList.push({
								datetime: localStorage[ele],
								pn: recentProd,
								pndisp: recentPnDisp,
								img: recentImg,
								cat: recentCat
							});
							++count;
							if (count === _recentStorage.length) {
								return resolve(recentList);
							}
						} else {
							localStorage.removeItem('recentList-' + recentProd);
							++count;
						}
					}).fail(() => {
						localStorage.removeItem('recentList-' + recentProd);
						++count;
					});
				});
			});

			Promise.all([p]).then(() => {
				recentList.sort((x, y) => {
					let xDate = x['datetime'];
					let yDate = y['datetime'];
					if (xDate > yDate) return -1;
					if (xDate < yDate) return 1;
					return 0;
				});
				if (recentList.length > 20) {
					localStorage.removeItem('recentList-' + recentList[20].pn);
					recentList.pop();
				}
				// console.log(recentList);

				let recentHTML = '';
				for (let l = 0; l < recentList.length; l++) {
					recentHTML += '<div><a href="/product/detail/' + recentList[l].pn + '/">' +
						`<figure><img src="${recentList[l].img}" oncontextmenu="return false;">` +
						`<figcaption>${recentList[l].cat}<br>${recentList[l].pndisp}</figcaption></figure></a></div>`;
				}
				$('.prodDetail-recentList').append(recentHTML);

				// 最近チェックした商品 画像右クリック禁止
				$('.prodDetail-recentList img').on('contextmenu', () => {
					return false;
				});

				recentCarousel();
				addRecentStorage(_thisPn);
			});
		}
		// 最近チェックした商品取得
		const getRecentList = (_thisPn) => {
			let recentStorage = [];

			for (let i in localStorage) {
				if (i.indexOf('recentList-') !== -1) {
					recentStorage.push(i);
				}
			}
			if (recentStorage.length > 0) {
				setRecentList(recentStorage, _thisPn);
			} else {
				$('.prodDetail-recent').remove();
				addRecentStorage(_thisPn);
			}
		}

		removeRecentThisItem(thisPn);
		getRecentList(thisPn);
	};

	// お気に入り処理
	const setFavo = () => {
		let $add = $('.prodDetail-favo ._add');
		let $del = $('.prodDetail-favo ._delete');
		let $chip = $('.prodDetail-favo .__favoChip');

		// お気に入り商品かチェック
		const checkFavo = (_thisPn) => {
			let favoriteFlag;
			for (let item in localStorage) {
				if (item.indexOf('favoriteList-') !== -1) {
					if (item.replace(/favoriteList-/, '') === _thisPn) {
						favoriteFlag = true;
					}
				}
			}
			if (!favoriteFlag) {
				$add.addClass(a);
			} else {
				$del.addClass(a);
			}
		}
		// お気に入りに追加,削除
		const addDeleteFavo = (_thisPn) => {
			// 追加
			$add.on('click', () => {
				let favoriteStorage = [];
				for (let i in localStorage) {
					if (i.indexOf('favoriteList-') !== -1) {
						favoriteStorage.push(i);
					}
				}
				if (favoriteStorage.length >= SANGETSU.va.favorite_num) {
					// すでに300件登録がある場合はチップ表示
					$chip.addClass(a);
					setTimeout(() => { $chip.addClass(v); });
					setTimeout(() => {
						$chip.removeClass(v);
						setTimeout(() => { $chip.removeClass(a); });
					}, 3000);
				} else {
					// なければ追加成功
					let favoriteDatetime = new Date();
					favoriteDatetime = `${favoriteDatetime.getFullYear()}/${('0' + (favoriteDatetime.getMonth() + 1)).slice(-2)}/${(('0' + (favoriteDatetime.getDate())).slice(-2))} ` +
						`${('0' + (favoriteDatetime.getHours())).slice(-2)}:${('0' + (favoriteDatetime.getMinutes())).slice(-2)}:${('0' + (favoriteDatetime.getSeconds())).slice(-2)}`;
					localStorage.setItem('favoriteList-' + _thisPn, favoriteDatetime);
					$add.removeClass(a);
					$del.addClass(a);
					SANGETSU.setFavoCount();
				}
			});

			// 削除
			$del.on('click', () => {
				localStorage.removeItem('favoriteList-' + _thisPn);
				$del.removeClass(a);
				$add.addClass(a);
				SANGETSU.setFavoCount();
			});
		}

		checkFavo(thisPn);
		addDeleteFavo(thisPn);
	};


	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	// メイン商品画像
	if ($('.__listImg').length) {
		mainImg();
	} else {
		$('.prodDetail-prodImg-list').remove();
		$('.mod-loader').remove();
		$('.prodDetail-wrap').addClass(v);
	}

	// チップ画像処理（上の方にあるので先にやる）
	if (cssua.ua.desktop) {
		setChipImgSize();
	}

	// Youtube動画
	if ($('.prodDetail-video-list li').length) {
		setYoutube();
	} else {
		$('.prodDetail-video').remove();
	}

	setPrice();
	formatSpec();
	diffProd();
	setRecommendList();
	setRecent();
	removeEmpty();
	setFavo();

})(window.jQuery, window.SANGETSU, window.cssua);
